import axios from "../../axios";
import makeApiCall from "../master/axiosIndex";
export const getCountrys = async () => {
  try {
    const res = await axios.get("/countries");
    const { data } = res.data;
    return data;
  } catch (error) {
    return [];
  }
};

export const getStatesByCountry = async (countryId: string) => {
  try {
    const res = await axios.get(`/stateByCountry?countryId=${countryId}`);
    const { data } = res.data;
    return data;
  } catch (error) {
    return [];
  }
};

const misc = {
  getCurrencyTypes: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/misc/currencyTypes",
    }),

  getOygTypes: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `admin/fetchCompanyTypes`,
    }),
  getTaxSlabs: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/misc/taxSlabs`,
    }),
  fetchOrganizationResponseByKeys: (): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/misc/fetchOrganizationResponseByKeys`,
      data: {
        type: "Seller",
      },
    }),
  fetchAllUomByType: (type: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/misc/fetchAllUomByType`,
      params: {
        type,
      },
    }),
  fetchSupplierCategoryFiltered: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/buyer/fetchSupplierCategoryFiltered`,
    }),
  fetchProductFiltered: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/buyer/fetchProductFiltered`,
    }),

  fetchProductByCategoryId: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/buyer/fetchProductByCategoryId`,
      params: {
        id,
      },
    }),
  fetchSiteUsers: (siteId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/buyer/fetchSiteUsers`,
      params: {
        siteId,
      },
    }),
};

export default misc;
